import React from 'react';
import 'loaders.css/loaders.css';

export const DotLoader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="ball-pulse">
        <div className="bg-info"></div>
        <div className="bg-info"></div>
        <div className="bg-info"></div>
      </div>
    </div>
  );
};
